import React from "react";
import { NavLink } from "react-router-dom";

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { logo: require("./../../images/header-logo.png") };
  }

  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("/assets/js/mobilenav.js");
  }

  render() {
    return (
      <ul className="nav navbar-nav">
        <li className="active">
          <NavLink to={"/"}>Home</NavLink>
          {/* <ul className="sub-menu">
                            <li><NavLink to={"/"}>Home-1</NavLink></li>
                            <li><NavLink to={"/home-2"}>Home-2</NavLink></li>
                            <li><NavLink to={"/home-3"}>Home-3</NavLink></li>
                            <li><NavLink to={"/home-4"}>Home-4</NavLink></li>
                            <li><NavLink to={"/home-5"}>Home-5</NavLink></li>
                            <li><NavLink to={"/home-6"}>Home-6</NavLink></li>
                        </ul> */}
        </li>
        <li>
          <NavLink to={"/about"}>About us</NavLink>
          {/* <ul className="sub-menu">
                           <li><NavLink to={"/team"}>Team</NavLink></li>  
                            <li><NavLink to={"/about-1"}>About 1</NavLink></li>
                            <li><NavLink to={"/about-2"}>About 2</NavLink></li>
                        </ul> */}
        </li>
        {/* <li>
                                <NavLink to={"/team"}>Team</NavLink>
                                <ul className="sub-menu">
                                    <li><NavLink to={"/team-1"}>Our Team 1</NavLink></li>
                                    <li><NavLink to={"/team-2"}>Our Team 2</NavLink></li>
                                    <li><NavLink to={"/team-single"}>Team Detail</NavLink></li>
                                </ul>
                            </li> */}
        {/* <li>
                        <NavLink to={""}>Pages</NavLink>
                        <ul className="sub-menu">
                            <li>
                                <NavLink to={""}>Services</NavLink>
                                <ul className="sub-menu">
                                    <li><NavLink to={"/services-1"}>Services 1</NavLink></li>
                                    <li><NavLink to={"/services-2"}>Services 2</NavLink></li>
                                    <li><NavLink to={"/services-detail"}>Service Detail</NavLink></li>
                                </ul>
                            </li>
                            <li>
                                <NavLink to={""}>Team</NavLink>
                                <ul className="sub-menu">
                                    <li><NavLink to={"/team-1"}>Our Team 1</NavLink></li>
                                    <li><NavLink to={"/team-2"}>Our Team 2</NavLink></li>
                                    <li><NavLink to={"/team-single"}>Team Detail</NavLink></li>
                                </ul>
                            </li>
                            <li><NavLink to={"/our-history"}>Our History</NavLink></li>
                            <li><NavLink to={"/icon-font"}>Fonts Icons</NavLink></li>
                            <li><NavLink to={"/error-404"}>Error 404</NavLink></li>
                        </ul>
                    </li> */}
        <li>
          <NavLink to={""}>Services</NavLink>

          <ul className="sub-menu">
            <li>
              <NavLink to={"/services/Receptions"}>Receptions</NavLink>
            </li>
            <li>
              <NavLink to={"/services/Weddings"}>Weddings</NavLink>
            </li>
            {/* <ul className="sub-menu">
                                    <li><NavLink to={"/services/Civil"}>Civil</NavLink></li>
                                    <li><NavLink to={"/services/Anand-Karaj"}>Anand Karaj</NavLink></li>
                                    <li><NavLink to={"/services/Mandaps"}>Mandaps</NavLink></li>
                                    <li><NavLink to={"/services/Nikkah"}>Nikkah</NavLink></li>
                                </ul> */}

            <li>
              <NavLink to={"/services/Home-Decor"}>Home Decor</NavLink>
            </li>
            <li>
              <NavLink to={"/services/Pre-Wedding"}>Pre-Wedding</NavLink>
            </li>
            {/* <li><NavLink to={"/services/Sangeet-Jaggo"}>Sangeet / Jaggo</NavLink></li> */}
            {/* <ul className="sub-menu">
                                    <li><NavLink to={"/services/Sangeet"}>Sangeet </NavLink></li>
                                    <li><NavLink to={"/services/Jaggo"}>Jaggo</NavLink></li>
                                    <li><NavLink to={"/services/Haldi-Maiyon"}>Haldi / Maiyon</NavLink></li>
                                    <li><NavLink to={"/services/Bridal-Shower"}>Bridal Shower</NavLink></li>
                                    <li><NavLink to={"/services/Proposals"}>Proposals</NavLink></li>
                                </ul> */}
          </ul>
        </li>
        <li>
          <NavLink to={"/rentals"}>Rentals</NavLink>
        </li>

        <li>
          {" "}
          <a
            href="https://www.tiktok.com/@sunlightcreationz?_t=8roDYxOkezY&_r=1"
            target="_blank"
          >
            <i className="fa-brands fa-tiktok" />
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/sunlightcreationz?igsh=NTF6dGI3bXYxOGNv"
            target="_blank"
          >
            {" "}
            <i className="fa-brands fa-instagram" />
          </a>
        </li>

        <li>
          <NavLink to={"/faq"}>FAQ</NavLink>
        </li>
        <li>
          <NavLink to={"/contact-us"}>Contact us</NavLink>
        </li>
      </ul>
    );
  }
}

export default Navigation;
